import React from 'react';

import { trackAdWordsConversion } from '../../../services/adWords';
import { trackAnalyticsEvent } from '../../../services/analytics';
import { T } from '../../../../../common/locale/translate';

import { add_email_to_newsletter_db } from '../../../services/services';

export default class NewsletterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userEmail: '',
      validationMessage: '',
      rodoMessage: '',
      messageClass: 'hidden'
    };
  }

  render = () => (
    <div className="form">
      <div>
        <div className="newsletter-label-wrapper">
          <label htmlFor="newsletter_email">
            <span>{T('your_email_address')}</span>
            <input
              type="email"
              name="newsletter[email]"
              id="newsletter_email"
              onChange={this.handleChange}
              onFocus={this.handleFocus}
              value={this.state.userEmail}
            />
          </label>
        </div>
        <button type="submit" onClick={this.handleSubmit}>
          {T('sign_up')}
        </button>
      </div>
      <span className={'form-message ' + this.state.messageClass}>
        {this.state.validationMessage}
      </span>
      <span className={'form-message ' + this.state.messageClass}>
        {this.state.rodoMessage}
      </span>
    </div>
  );

  handleChange = event => this.setState({ userEmail: event.target.value });

  handleFocus = () => {
    this.setState({
      rodoMessage: T('rodo_info'),
      messageClass: 'visible'
    });
  };

  handleSubmit = () => {
    if (this.validateEmail()) {
      trackAdWordsConversion(715672677, 'omQECODpj3IQrZTnlwM');
      trackAnalyticsEvent(
        'newsletter',
        'zapis do newslettera',
        'zapis przez formularz newslettera'
      );
      this.saveEmailToNewsletter();
    } else {
      let message = T('invalid_email_message');
      this.setMessage(true, message);
    }
  };

  validateEmail() {
    let emailValidationCondition = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return emailValidationCondition.test(this.state.userEmail);
  }

  setMessage(isVisible, message) {
    this.setState({
      validationMessage: message,
      messageClass: isVisible ? 'visible' : 'hidden'
    });
  }

  getCsrfToken() {
    return document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute('content');
  }

  saveEmailToNewsletter() {
    const csrfToken = this.getCsrfToken();
    add_email_to_newsletter_db(this.state.userEmail, csrfToken)
      .then(() => {
        let message = T('newsletter_after_sign_up');
        this.setMessage(true, message);
        this.setState({ userEmail: '' });
      })
      .catch(error => {
        let message = error.response.data.message;
        this.setMessage(true, message);
      });
  }
}



// WEBPACK FOOTER //
// ./app/javascript/layout/components/newsletter/newsletter_form.jsx